import React, { useState } from "react";
import WeatherInfo from "./WeatherInfo";
import Forecast from "./Forecast";

import axios from "axios";
import "./Weather.css";

import { Rings } from "react-loader-spinner";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);

  function handleResponse(response) {
    console.log(response.data);
    setWeatherData({
      ready: true,
      temperature: Math.round(response.data.temperature.current),
      city: response.data.city,
      description: response.data.condition.description,
      wind: response.data.wind.speed,
      humidity: response.data.temperature.humidity,
      date: new Date(response.data.time * 1000),
      icon: response.data.condition.icon,
    });
  }

  function search() {
    const apiKey = "9680t975994o0f740a177548a039f54b";
    let apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  if (weatherData.ready) {
    return (
      <div className="Weather">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-9">
              <input
                type="search"
                placeholder="Find your city..."
                className="form-control"
                autoFocus="on"
                onChange={handleCityChange}
              />
            </div>
            <div className="col-md-3">
              <input type="submit" value="Search" className="btn px-4" />
            </div>
          </div>
        </form>
        <div className="row">
          <div className="col-md-7">
            <WeatherInfo data={weatherData} />
          </div>
          <div className="col-md-5">
            <Forecast data={weatherData} />
          </div>
        </div>
      </div>
    );
  } else {
    search();
    return (
      <div className="d-flex justify-content-center">
        <Rings
          height="480"
          width="480"
          color="rgba(255, 255, 255, 0.5)"
          radius="5"
          visible={true}
          ariaLabel="rings-loading"
        />
      </div>
    );
  }
}
